export const SERVICE_ENDPOINT = process.env.REACT_APP_SERVICE_ENDPOINT;
export const AWS_REGION = process.env.REACT_APP_AWS_REGION;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
